export default __webpack_public_path__ + "static/media/uploader-caresensBt-problem-2.7d9604e2.png";